import CryptoJS from 'crypto-js';
import { ENCRYPTION_SECRET_KEY } from '@/constants/Config';

export const encryptPayload = (payload: unknown) => {
  const iv = CryptoJS.lib.WordArray.random(16);

  const encrypted = CryptoJS.AES.encrypt(
    JSON.stringify(payload),
    CryptoJS.enc.Utf8.parse(ENCRYPTION_SECRET_KEY),
    {
      iv,
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC,
    }
  );

  return {
    iv: iv.toString(CryptoJS.enc.Hex),
    ciphertext: encrypted.toString(),
  };
};

export const decrypt = (encryptedData: string, key: string, iv: string) => {
  const decrypted = CryptoJS.AES.decrypt(encryptedData, CryptoJS.enc.Base64.parse(key), {
    iv: CryptoJS.enc.Base64.parse(iv),
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  return CryptoJS.enc.Utf8.stringify(decrypted);
};
